// Validate a post-login `next` destination passed via URL query (e.g. from the
// marketing top-matches link). Returns the path only if it is a safe INTERNAL
// app path; otherwise null. Guards open-redirect (absolute / protocol-relative
// URLs) and limits to the provider area, the internal marketing overview, and
// a feed doctor's fixed route. Company ownership is still checked by its API.
const ALLOWED_PREFIXES = ['/provider/'];
const COMPANY_DOCTOR_PATH = /^\/company\/job-feed\/[a-fA-F\d]{24}\/health-report(?:\?(?:after|resume)=[a-fA-F\d]{24})?$/;
const MCP_PUBLICATION_REVIEW_PATH = '/company/mcp-publication';
const MCP_OAUTH_CALLBACK_PATH = '/mcp/oauth/callback';

export function safeInternalNext(raw) {
  if (!raw || typeof raw !== 'string') return null;
  if (!raw.startsWith('/') || raw.startsWith('//')) return null;
  const allowedProviderPath = ALLOWED_PREFIXES.some((p) => raw.startsWith(p));
  const allowedMarketingPath =
    raw === '/marketing/overview' || raw.startsWith('/marketing/overview?');
  const allowedCompanyDoctorPath = raw === raw.trim() && COMPANY_DOCTOR_PATH.test(raw);
  const allowedMcpPublicationPath = raw === MCP_PUBLICATION_REVIEW_PATH;
  const allowedMcpOAuthCallbackPath = raw === MCP_OAUTH_CALLBACK_PATH;
  if (
    !allowedProviderPath &&
    !allowedMarketingPath &&
    !allowedCompanyDoctorPath &&
    !allowedMcpPublicationPath &&
    !allowedMcpOAuthCallbackPath
  ) return null;
  return raw;
}
